/**
 * Promo badges verifier for the custom-promo-badges block.
 *
 * The -XX% discount badge is now rendered server-side (synchronously with
 * NEW / Final Sale), so it paints in the same frame with no JS-timed fill.
 * This script only VERIFIES that badge:
 *   - Reads data-discounts (JSON array of {pct, from, to}).
 *   - Computes the entry whose time window contains "now" with the largest
 *     pct (overlapping automatic discounts compete, best deal wins).
 *   - If the server-rendered badge already shows that pct -> no-op.
 *   - Otherwise it replaces the badge (edge cases: sale not started / ended,
 *     or an overlapping active entry that isn't the max) or removes it when
 *     nothing is active. Final Sale stays independent, not mutex.
 */
(function () {
  function parseDate(s) {
    if (!s) return null;
    const t = new Date(s).getTime();
    return isNaN(t) ? null : t;
  }

  function activeEntries(entries) {
    const now = Date.now();
    return (entries || []).filter(function (e) {
      const from = parseDate(e.from);
      const to   = parseDate(e.to);
      if (from !== null && now < from) return false;
      if (to   !== null && now > to)   return false;
      return true;
    });
  }

  function detectSize(root) {
    const ref = root.querySelector('.custom-promo-badge');
    if (!ref) return 'small';
    const m = ref.className.match(/custom-promo-badge--size-(\w+)/);
    return m ? m[1] : 'small';
  }

  function renderBadge(entry, size) {
    const span = document.createElement('span');
    span.className = 'custom-promo-badge custom-promo-badge--discount custom-promo-badge--size-' + size;
    span.dataset.pct = entry.pct;
    const txt = document.createElement('span');
    txt.className = 'custom-promo-badge__text';
    txt.textContent = '-' + entry.pct + '%';
    span.appendChild(txt);
    return span;
  }

  function render(root) {
    if (root.dataset.showDisc !== 'true') return;

    let entries = [];
    try { entries = JSON.parse(root.dataset.discounts || '[]'); }
    catch (e) { return; }

    // Active = time window contains "now" and a real discount (> 0%).
    const active = activeEntries(entries).filter(function (e) { return e.pct > 0; });

    // Pick the largest pct; on ties keep the first encountered.
    const best = active.reduce(function (a, b) {
      return (b.pct > (a ? a.pct : -1)) ? b : a;
    }, null);

    const slot = root.querySelector('[data-discount-badge-slot]');
    if (!slot) return;

    if (!best) {
      // Nothing active — remove any stale server-rendered badge.
      if (slot.childElementCount) slot.innerHTML = '';
      return;
    }

    // Server already rendered exactly this pct -> no-op (the common case).
    const existing = slot.querySelector('.custom-promo-badge--discount');
    if (existing && Number(existing.dataset.pct) === best.pct) return;

    slot.innerHTML = '';
    slot.appendChild(renderBadge(best, detectSize(root)));
  }

  function renderAll() {
    document.querySelectorAll('[data-block-promo-badges]').forEach(render);
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', renderAll);
    } else {
      renderAll();
    }
  }
  init();

  let scheduleTimer = null;
  function scheduleRender() {
    if (scheduleTimer) return;
    scheduleTimer = setTimeout(function () { scheduleTimer = null; renderAll(); }, 0);
  }

  const bodyObserver = new MutationObserver(function (mutations) {
    let dirty = false;
    for (const m of mutations) {
      if (m.type === 'childList') {
        if (m.addedNodes.length) { dirty = true; break; }
        for (const n of m.removedNodes) {
          if (n && n.nodeType === 1 && n.hasAttribute && n.hasAttribute('data-block-promo-badges')) { dirty = true; break; }
        }
        if (dirty) break;
      } else if (m.type === 'attributes' && m.attributeName === 'data-discounts') {
        dirty = true; break;
      }
    }
    if (dirty) scheduleRender();
  });
  bodyObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-discounts'] });

  document.addEventListener('product-select', function () { scheduleRender(); });
})();